module.exports = __webpack_public_path__ + "static/media/circle_check.8d92df13.svg";